module.exports = __webpack_public_path__ + "static/media/kyte.899970d6.svg";